import CtaSection from '~/landingV4/components/CtaSection'
import FaqSection from '~/landingV4/components/FaqSection'
import HeroSection from '~/landingV4/components/HeroSection'
import PricingSection from '~/landingV4/components/PricingSection'
import QuizSection from '~/landingV4/components/QuizSection'
import TopicsSection from '~/landingV4/components/TopicsSection'

export default function LandingV4(): React.ReactElement {
  return (
    <div className="flex flex-col bg-lavender-light text-black-ink overflow-x-hidden">
      <HeroSection />
      <QuizSection />
      <TopicsSection />
      <PricingSection />
      <FaqSection />
      <CtaSection />
    </div>
  )
}
